
import React from 'react'
import { useEffect, useState } from 'react'
import * as S from './styles'

//components
import Loading from '../../shared/components/Loading'
import { DownloadApp } from '../../shared/components/DownloadApp'
import { useNavigate, useParams } from 'react-router-dom'
import { usePix } from '../../shared/services/payment.service'
import routesEnum from '../Routes/enum'
import { useTranslation } from 'react-i18next'
import { Navigate, useLocation } from 'react-router-dom'

//images
import AntagonistaLogo from '../../assets/images/logo-antagonista-crusoe-preto.svg'

//utils
import ReactHtmlParser from 'react-html-parser'
import { CopyCodeBar } from '../../shared/components/CopyCodeBar'
import QRCode from 'react-qr-code'


function EndView(props: any) {
	const urlParams = new URLSearchParams(window.location.search)

	const data = {
		email: props.email,
		pix_print_url: props.pix_print_url,
		pix_qr_code: props.pix_qr_code,
		status: props.bill_status
	}
	const { t } = useTranslation('payment')
	const { subscription_id } = useParams()
	const navigate = useNavigate()

	const url = window.location.pathname

	const [componentInitial, setComponentInitial] = useState<any>(null)
	const [componentCheckEmailInbox, setComponentCheckEmailInbox] = useState<any>(null)
	const [pixPaidButton, setPixPaidButton] = useState<boolean>(false)
	const [showPixPaidButton, setShowPixPaidButton] = useState(false);

	useEffect(() => {
		if (url.includes('pix')) {
			const timeoutId = setTimeout(() => {
				// window.location.href = "https://assine.oantagonista.com.br/assine-o-antagonista?hs_preview=JalNNDUT-128888952908&plano=${plan}";
				setShowPixPaidButton(true);
			}, 15000);

			// Cleanup to clear the timeout if the component is unmounted before 30 seconds
			return () => clearTimeout(timeoutId);
		}
	}, [url]);

	if (url.includes('pix') && !subscription_id) {
		return <Navigate to={routesEnum.HOME} />
	}

	function moveToSite() {
		window.open('https://oantagonista.com.br', '_blank')
	}

	function moveToRegister() {
		navigate(-1);
	}

	function InitialComponent() {

		if (url.includes('credit') && data.status === 'paid') {

			window.localStorage.removeItem('registerForm')
			window.location.href = "https://assine.oantagonista.com.br/assinante?plano="+urlParams.get("plano");
			return null;
			// return (<S.StatusContainer>
			// 	<S.ImagesContainer>
			// 		<img src={AntagonistaLogo} alt='Logo o antagonista e crusoé' />
			// 	</S.ImagesContainer>
			// 	<S.StatusMessage>{t('SUBSCRIPTION_SUCCESS')}</S.StatusMessage>
			// 	<S.ThankyouMessage>
			// 		{ReactHtmlParser('Acesse o site e faça o login')}
			// 	</S.ThankyouMessage>
			// 	<S.Button variation={2} onClick={moveToSite}>
			// 		login
			// 	</S.Button>
			// 	<div style={{ marginBottom: 50 }}></div>
			// </S.StatusContainer>)
		}

		if (url.includes('credit') && data.status !== 'paid') {

			return (
				<S.StatusContainer>
					<S.ImagesContainer>
						<img src={AntagonistaLogo} alt='Logo o antagonista e crusoé' />
					</S.ImagesContainer>
					<S.StatusMessage>{t('SUBSCRIPTION_FAILURE')}</S.StatusMessage>
					<S.FailureMessage>
						{ReactHtmlParser(t('SUBSCRIPTION_ERROR_MESSAGE'))}
					</S.FailureMessage>

					<S.Button variation={2} onClick={moveToRegister}>
						{t('CORRECT_DATA')}
					</S.Button>
				</S.StatusContainer>
			)
		}

		if (url.includes('pix') && data.status === 'paid') {

			window.localStorage.removeItem('registerForm')
			window.location.href = "https://assine.oantagonista.com.br/assinante?plano="+urlParams.get("plano");
			return null;
			
		}

		if (url.includes('pix') && data.status !== 'paid') {

			return <>
				<S.Title>{t('PAYMENT_TITLE')}</S.Title>

				{showPixPaidButton && (
					<S.Button variation={2} onClick={() => {
						window.localStorage.removeItem('registerForm')
						window.location.href = "https://assine.oantagonista.com.br/assinante?plano="+urlParams.get("plano");
					}}>
						{'Já paguei o pix'}
					</S.Button>
				)}

				<S.PaymentTypeContainer>
					<S.Container>
						<QRCode value={data?.pix_qr_code || ''} />

						<S.Hr />

						<S.CopyText>{t('COPY_TEXT')}</S.CopyText>

						<CopyCodeBar code={data?.pix_qr_code || ''} />
					</S.Container>
				</S.PaymentTypeContainer>
			</>
		}

		return null
	}


	function ComponentCheckEmailInbox() {
		return <>
			<S.StatusContainer>
				<S.ImagesContainer>
					<img src={AntagonistaLogo} alt='Logo o antagonista e crusoé' />
				</S.ImagesContainer>
				<S.StatusMessage>{'Perfeito! Agora verifique o comprovante de pagamento que chegou no seu e-mail para ver se está tudo certinho e faça o login'}</S.StatusMessage>
				<S.Button variation={2} onClick={() => setPixPaidButton(false)}>
					{'Ainda não paguei o Pix'}
				</S.Button>
				<div style={{ marginBottom: 50 }}></div>
				<S.ThankyouMessage>
					{ReactHtmlParser('Acesse o site e faça o login')}
				</S.ThankyouMessage>
				<S.Button variation={2} onClick={moveToSite}>
					login
				</S.Button>
				<div style={{ marginBottom: 50 }}></div>
			</S.StatusContainer>
		</>
	}

	return (
		<S.Container>
			{!pixPaidButton && <InitialComponent />}
			{pixPaidButton && <ComponentCheckEmailInbox />}
			<DownloadApp />
		</S.Container>
	)
}

export { EndView }
